import React from 'react';
import styled from 'styled-components';

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-bottom: 16px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: ${({ theme }) => theme?.backgroundPage || '#fff'};
`;

export const Th = styled.th`
  padding: 8px 12px;
  background: ${({ theme }) => theme?.podiumBackground || '#f5f5f5'};
  color: ${({ theme }) => theme?.titleColor || '#101325'};
  border-bottom: 2px solid ${({ theme }) => theme?.podiumBorder || '#e0e0e0'};
  text-align: left;
`;

export const Td = styled.td`
  padding: 8px 12px;
  border-bottom: 1px solid ${({ theme }) => theme?.listItemBorder || '#e0e0e0'};
`;

export const SectionTitle = styled.h2`
  font-size: 1.4em;
  margin: 32px 0 16px 0;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Card = styled.div`
  background: ${({ theme }) => theme?.modalContentBackground || '#fff'};
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(16,19,37,0.06);
  padding: 24px;
  margin-bottom: 32px;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  color: #e4312e;
  cursor: pointer;
  font-size: 1.1em;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
  &:hover {
    background: #fbeaea;
  }
`;

export const Button = styled.button`
  background: #101325;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 8px 20px;
  font-size: 1em;
  cursor: pointer;
  margin-top: 8px;
  margin-bottom: 8px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  &:hover {
    background: #e4312e;
  }
`;

export const Label = styled.label`
  font-weight: 600;
  margin-bottom: 4px;
  display: block;
`;

export const FormGroup = styled.div`
  margin-bottom: 18px;
`;

export const Input = styled.input`
  padding: 7px 10px;
  border: 1px solid #d2d2d2;
  border-radius: 4px;
  font-size: 1em;
  width: auto;
  min-width: 0;
`;

export const Select = styled.select`
  padding: 7px 10px;
  border: 1px solid #d2d2d2;
  border-radius: 4px;
  font-size: 1em;
  width: auto;
  min-width: 0;
`;

export const TextArea = styled.textarea`
  padding: 7px 10px;
  border: 1px solid #d2d2d2;
  border-radius: 4px;
  font-size: 1em;
  width: 100%;
  min-height: 60px;
  resize: vertical;
`;
